module.exports = __webpack_public_path__ + "img/no-data.032d3505.png";